import type { QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  useLocation,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import {
  outsidePasswordProtectionPaths,
  PasswordProtection,
  useShouldShowPasswordProtection,
} from "@/components/PasswordProtection";
import { env } from "@/env";
import type { AuthContext } from "@/features/auth";
import { ErrorPage } from "@/features/shared/ErrorPage";
import { NotFoundPage } from "@/features/shared/NotFoundPage";

type AppRouterContext = {
  auth: AuthContext;
  queryClient: QueryClient;
};

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: () => {
    // TODO password: Fjern når passordbeskyttelse ikke er nødvendig lenger. Husk å fjerne komponenten og hooken også.
    const location = useLocation();

    const [isOutsidePasswordProtection, setIsOutsidePasswordProtection] =
      useState<boolean>(false);
    const passwordProtection = useShouldShowPasswordProtection();

    useEffect(() => {
      const outside = (outsidePasswordProtectionPaths as string[]).includes(
        location.pathname,
      );
      setIsOutsidePasswordProtection(outside);
    }, [location.pathname]);

    const showPasswordProtection =
      passwordProtection.passwordIsRequired &&
      (passwordProtection.isAuthenticated || !isOutsidePasswordProtection);
    return (
      <>
        <HeadContent />
        <Layout>
          {showPasswordProtection && <PasswordProtection />}
          <Outlet />
          {env.isDebug && (
            <>
              <TanStackRouterDevtools
                position="bottom-right"
                toggleButtonProps={{
                  // Er ikke className for denne
                  // @ts-expect-error("propery is called class and not className")
                  class: "mr-0 mb-14",
                }}
              />
              <ReactQueryDevtools initialIsOpen={false} />
            </>
          )}
        </Layout>
      </>
    );
  },
  errorComponent: () => (
    <Layout>
      <ErrorPage />
    </Layout>
  ),
  notFoundComponent: () => <NotFoundPage />,
});
